(() => {
  'use strict';

  const config = document.querySelector('script[data-lp-myshop-contact]');
  if (!config || window.lpMyShopContactReady) return;
  const contactUrl = new URL(config.dataset.contactUrl, window.location.origin);
  if (contactUrl.origin !== window.location.origin) return;
  window.lpMyShopContactReady = true;

  const rootSelector = '#wfb-wrapper.wfb-wrapper';
  const linkSelector = '.wfb-buttons > a.wfb-platform-btn[data-platform="email"]';

  function update(root) {
    root.querySelectorAll(linkSelector).forEach((link) => {
      const href = link.getAttribute('href') || '';
      const original = /^mailto:support@luminipet\.com(?:\?|$)/i.test(href);
      const converted = link.dataset.lpMyshopContact === 'true' && link.href === contactUrl.href;
      if (!original && !converted) return;
      if (link.href !== contactUrl.href) link.href = contactUrl.href;
      if (link.target !== '_self') link.target = '_self';
      if (link.getAttribute('aria-label') !== 'Contact Us') link.setAttribute('aria-label', 'Contact Us');
      if (link.title !== 'Contact Us') link.title = 'Contact Us';
      if (link.dataset.lpMyshopContact !== 'true') link.dataset.lpMyshopContact = 'true';
      const tooltip = link.querySelector('.wfb-tooltip');
      if (tooltip && tooltip.textContent !== 'Contact Us') tooltip.textContent = 'Contact Us';
    });
  }

  function attach(root) {
    update(root);
    new MutationObserver(() => update(root)).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href'],
      characterData: true
    });
  }

  function start() {
    const root = document.querySelector(rootSelector);
    if (root) {
      attach(root);
      return;
    }
    const discovery = new MutationObserver(() => {
      const widget = document.querySelector(rootSelector);
      if (!widget) return;
      discovery.disconnect();
      clearTimeout(expiry);
      attach(widget);
    });
    discovery.observe(document.body, { childList: true, subtree: true });
    const expiry = setTimeout(() => discovery.disconnect(), 30000);
    window.addEventListener('pagehide', () => discovery.disconnect(), { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
